var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0AF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m22.75 25.25 8.75-8.75m-8.644 9.023 2.19 5.632c.193.496.29.744.428.817.12.063.264.063.385 0 .139-.072.236-.32.43-.816l5.491-14.073c.175-.448.262-.672.214-.815a.417.417 0 0 0-.263-.263c-.143-.048-.367.04-.814.214l-14.073 5.492c-.496.194-.744.29-.816.43a.417.417 0 0 0 0 .384c.072.14.32.236.817.429l5.631 2.19a.94.94 0 0 1 .194.089c.037.027.07.06.097.097a.89.89 0 0 1 .089.194Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 14h20v20H14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon4);
export default __webpack_public_path__ + "static/media/send-icon4.aecbaba8969d63f7a856bd6dd2562b49.svg";
export { ForwardRef as ReactComponent };